import {useMemo} from 'react';

import classNames from 'classnames';

import {Stack} from 'shells/layout/stack/stack';

import type {PeepRelatedLeadStatsFragment} from 'nutshell-graphql-types';

import {getStatsValues} from './helpers';
import {LeadStat} from './lead-stat';

interface Props {
    stats: PeepRelatedLeadStatsFragment;
    hasSmallSidebar: boolean;
}

export function LeadStats(props: Props) {
    const statsValues = useMemo(() => {
        return getStatsValues(props.stats);
    }, [props.stats]);

    const shouldUseFixedGap = statsValues.length === 2;

    // !hasSmallSidebar -> Padding/margin match the card widget's tabs
    const styles = classNames('pb-8', props.hasSmallSidebar ? 'pl-16 pr-8' : 'mr-16 px-16');

    return (
        <div className={styles}>
            <Stack
                isHorizontal={true}
                spacing={shouldUseFixedGap ? 60 : undefined}
                justifyContent={shouldUseFixedGap ? undefined : 'space-between'}
                wrap={true}
            >
                {statsValues.map((stat) => (
                    <LeadStat key={stat.status} status={stat.status} stat={stat.stat} />
                ))}
            </Stack>
        </div>
    );
}
